export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13894.998a9cf6.jpg";